//
//  BloodPressureBox.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Box, Grid, Typography } from "@mui/material";

interface ValueBoxProps {
  label: string;
  value: number;
}

const ValueBox = ({ label, value }: ValueBoxProps) => (
  <Box p={2} style={{ textAlign: "center" }}>
    {/* タイトル */}
    <Typography variant="h5">{label}</Typography>
    {/* 値 */}
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography mr={1} variant="h2">
        {value}
      </Typography>
    </Box>
  </Box>
);

interface BloodPressureSummaryProps {
  measurementDateString: string;
  measurementData: {
    max: number;
    min: number;
    pulse: number;
  };
}

const BloodPressureSummary = ({
  measurementDateString,
  measurementData,
}: BloodPressureSummaryProps) => (
  <Box
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    {/* 測定日 */}
    <Typography variant="h5" fontWeight={"bold"}>
      {measurementDateString}
    </Typography>
    {/* 測定結果ボックス */}
    <Box m={1} style={{ border: "1px solid #AAA", width: "70%" }}>
      <Grid container>
        <Grid size={4}>
          <ValueBox label="最高血圧" value={measurementData.max} />
        </Grid>
        <Grid size={4}>
          <ValueBox label="最低血圧" value={measurementData.min} />
        </Grid>
        <Grid size={4}>
          <ValueBox label="最高脈拍" value={measurementData.pulse} />
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default BloodPressureSummary;
